import React, { Component } from "react";
import Nav from "./Nav/Nav";

class Header extends Component {
  render() {
    return < Nav/>
  }
}

export default Header;
